<template>
  <div class="container d-flex">
    <a class="hyper-section" name="main"></a>
<section> <h1>
Välkommen till Magdalena Bygg och Måleri!</h1>   
<p>  Söker ni ett professionellt bygg & måleriföretag med mycket erfarenhet och kun-skap? Då är Magdalena Bygg & Måleri rätt företag för er! 
Vi jobbar med allt inom bygg och måleri. Tveka inte på att höra av er till oss och berätta om era behov, önskemål eller drömmar! Vi skickar gärna en offert till er med prisförslag.
Mitt namn är Hany Rezkalla och jag är född 1977. Jag har lång erfarenhet inom bygg och renovering och har jobbat med allt inom byggnad - både stora och små projekt - internt och utvändigt. 

Jag är hantverkare från grunden då jag är uppvuxen i en familj med eget företag inom bygg och måleri. Jag har under min ”grundutbildning”, inom familjeföretaget, byggt på mina kunskaper ännu mer genom att besöka  Tekniska Gymnasieskola. 

Jag är väldigt strukturerad, noggrann, arbetsam och samarbetsvillig. Jag presterar bra under stress och har ett professionellt kundbemötande. Som hantverkare hos dig/er kan jag bidra med min gedigna arbetslivserfarenhet. 

Jag ser fram emot ett personligt möte med dig/er för att höra och se vad jag kan hjälpa dig/er med!
.</p>	
</section>
  </div> 
 
 



</template>

<script>
export default {

}
</script>

<style>

</style>